import { PHASE_STATUS, JITSI_SERVER_DOMAIN, ENABLE_SIMULCAST } from './vice-constants';

export const jitsiConfig = {
  options: {
    serviceUrl: `wss://${JITSI_SERVER_DOMAIN}/xmpp-websocket`,
    hosts: {
      domain: JITSI_SERVER_DOMAIN,
      muc: `conference.${JITSI_SERVER_DOMAIN}`,
    },
    useStunTurn: true,
    websocketKeepAlive: 0,
  },
  conference: {
    disableSimulcast: !ENABLE_SIMULCAST,
    openBridgeChannel: 'websocket',
    enableLayerSuspension: true,
    p2p: {
      enabled: false,
    },
  },
};

export const phasesData = {
  1: {
    id: 1,
    title: 'Introduction',
    status: PHASE_STATUS.WAITING,
    duration: 0,
    previousPhaseTitle: 'Lobby',
  },
  2: {
    id: 2,
    title: 'Consultation',
    status: PHASE_STATUS.WAITING,
    duration: 0,
    previousPhaseTitle: 'Introduction',
  },
  3: {
    id: 3,
    title: 'Debrief',
    status: PHASE_STATUS.WAITING,
    duration: 0,
    previousPhaseTitle: 'Consultation',
  },
};
